import { IRole } from "../rol/roleInterfaces";

/**
 * Interfaz que define la estructura de un usuario bloqueado.
 */
export interface IBlockedUser {
  id: number;
  username: string;
  locked: boolean;
}

/**
 * Interfaz para representar la solicitud de cambio de contraseña de un usuario.
 */
export interface IChangePassword {
  id: number;
  username: string;
  currentPassword: string;
  newPassword: string;
}

/**
 * Interfaz que define la estructura de un usuario en el sistema.
 */
export interface IUser {
  id: number;
  email: string;
  username: string;
  locked: boolean;
  status: boolean;
  roles: IRole;
  twoFactorEnabled?: boolean; // 🔹 Agregamos el estado de 2FA
}


/**
 * 🎯 Formulario maestro para creación / actualización de usuario
 * El backend decide qué campos usar según el endpoint.
 */
export interface IUserForm {
  id: number;               // create usa 0
  username: string;
  email: string;
  password: string | null;  // solo enviar si cambia
  confirmPassword: string | null; // solo UI, se elimina antes de enviar
  roleIds: number[];        // uno o más roles asignados al usuario
  branchIds: number[];      // una o más sucursales asignadas al usuario
  locked: boolean;          // update
  status: boolean;          // update
  twoFactorEnabled: boolean;
}


export const initialUserForm: IUserForm = {
  id: 0,
  username: null,
  email: null,
  password: null,
  confirmPassword: null,
  roleIds: [],
  branchIds: [],
  locked: false,
  status: true,
  twoFactorEnabled: false,
};
